import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../../helper/api";


export const sendOTP = createAsyncThunk(
  "sendOTP/sendOTP",
  async (payload, thunkAPI) => {
    try {
      const response = await api.post("send-otp-to-verify");
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("Something went wrong");
    }
  }
);

const sendOTPSlice = createSlice({
  name: "sendOTP",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(sendOTP.pending, (state) => {
        state.loading = true;
      })
      .addCase(sendOTP.fulfilled, (state, action) => {
          
          
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(sendOTP.rejected, (state, action) => {
        
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default sendOTPSlice.reducer;
